import io from 'socket.io-client';
import MSGS from './serverMessagesTypes';

var skt = {
  exercise: {},
  users: [],
  name: null,
  socket: null,
  userId: null,
  code: null,
  token: null
};

skt.sendTextMessage = function sendTextMessage(target, message) {
  skt.socket.emit(MSGS.TEXT_MSG, { target, message });
};

skt.sendUserMove = function sendUserMove(location) {
  skt.socket.emit(MSGS.USR_MOVE, { location });
};

skt.disconnect = function disconnect() {
  skt.socket.disconnect();
};

skt.sendSync = function sendSync() {
  skt.socket.emit(MSGS.USR_READY);
};

skt.changeVar = function changeVar(key, value) {
  skt.socket.emit(MSGS.SET_VAR, { key, value });
};

skt.start = function start(host, token, name, code) {
  skt.name = name;
  skt.host = host;
  skt.token = token;
  skt.code = code;

  skt.socket = io(host, { token });
};

skt.auth = function() {
  skt.socket.emit(MSGS.R_AUTH, { token: skt.token });
}

skt.on = function(message, callback) {
  if (skt.socket && skt.socket.on) {
    skt.socket.on(message, callback);
  }
};

export default skt;
